var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1788 11.572L11.6239 11.4842L11.851 11.0915L17.5302 1.27103C17.7392 0.909648 18.2609 0.909658 18.4698 1.27105L24.1485 11.0915L24.3756 11.4842L24.8207 11.572L34.5609 13.4935C34.959 13.572 35.1333 14.0437 34.882 14.3622L28.3749 22.608L28.1231 22.927L28.1653 23.3313L29.321 34.3979C29.3664 34.8329 28.905 35.1403 28.5211 34.9306L18.4792 29.4473L18 29.1856L17.5207 29.4473L7.47841 34.9306C7.09416 35.1404 6.63242 34.8324 6.67859 34.397L7.86803 23.1826L7.9117 22.7708L7.65145 22.4487L1.12193 14.3671C0.865225 14.0493 1.03828 13.5726 1.43905 13.4935L11.1788 11.572Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.65493c366ec799c0dc41bc54e86febc5.svg";
export { ForwardRef as ReactComponent };